import { User_Role } from '@occc/graphql';
import { useUserSelector } from '@occc-app/App/AppContext';

import { useRetailerNetworkUserSelector } from '../../retailer-network-context/use-retailer-network-user.selector';

export const useGetIsUserPermittedToRemoveUserFromNetwork = (
  isTargetUserSiteAdminOrUser: boolean,
) => {
  const currentUser = useUserSelector();
  const { isRetailerNetworkUser, isRetailerNetworkAdmin } = useRetailerNetworkUserSelector();

  const isCurrentUserAdmin = currentUser?.userRole === User_Role.Admin;

  return (
    isCurrentUserAdmin ||
    isRetailerNetworkAdmin ||
    (isRetailerNetworkUser && isTargetUserSiteAdminOrUser)
  );
};
